import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=32d27ecb&scoped=true"
import script from "./CardCategory.vue?vue&type=script&lang=js"
export * from "./CardCategory.vue?vue&type=script&lang=js"
import style0 from "./CardCategory.vue?vue&type=style&index=0&id=32d27ecb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d27ecb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d27ecb')) {
      api.createRecord('32d27ecb', component.options)
    } else {
      api.reload('32d27ecb', component.options)
    }
    module.hot.accept("./CardCategory.vue?vue&type=template&id=32d27ecb&scoped=true", function () {
      api.rerender('32d27ecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/CardCategory.vue"
export default component.exports